/**
 * Mount point.
 *
 * `StrictMode` is deliberately on: the session fetch and the developer-content
 * fetch both run in effects, and double-invocation in development is what would
 * catch either of them being written in a way that is not idempotent.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app.js';

const host = document.getElementById('root');
if (!host) throw new Error('#root is missing from index.html');

createRoot(host).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
